//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  getSellerShippingServices,
  // getNovaposhtaCities,
  // getNovaposhtaWarehouses,
} from '@api/order.service'
import {
  CITIES_URL,
} from '@api/vendor.service'

import pathOr from 'ramda/src/pathOr'

import { getPaginatedProps } from '@utils/valuesGetter';

import {
  receiveResource, createResource,
} from '@resource/resource'

import cancellablePromiseProxy from '@aspectus/cancellable-promise-proxy';

const FIRST_PAGE_LIMIT = 0

export default {
  name: 'OrderDelivery',
  props: {
    fields: {},
    getOnCreate: {
      default: true,
    },
    initialCity: {},
  },
  keyGetter: x => `${x.type}:${x.id}`,
  data() {
    return {
      variants: [],
      list: [],
      selected: '',
      city: null,
      // city: this.getInitialCity(),
      form: {
        shop: this.fields.shop,
        city: '',
        shipping_info: '',
        shipping_service: '',
      },
      city_config: {
        size: 'g-cols--12-xl',
        title: this._('Город'),
        rules: 'required',
        name: 'city',
        tag: 'd-control-multiselect',
        events: {
          open: $event => this.getCities($event, 'new_post_courier', 'city'),
          'search-change': $event => this.getCities($event, 'new_post_courier', 'city'),
          input: $event => {
            this.form.city = $event
            this.city = $event
            this.$emit('input', this.form)
          },
        },
        // input: () => this.getShippingVariantsAndClear(),
        afterList: visible => { this.getCities('', 'new_post_courier', 'city', true, visible) },
        props: {
          pagination: {},
          options: [],
          label: 'caption',
          customLabel: this.getCityLabel,
          searchable: true,
          preserveSearch: false,
          internalSearch: false,
          search: '',
          loading: false,
        },
      },
      // shipping_variant: [],
      isLoading: false,
      WIDGETS_MAP: {
        autocomplete_single: {
          tag: 'd-control-multiselect',
          props: {
            label: 'caption',
          },
          events: {
            open: this.getAndGenerate,
            'search-change': this.getAndGenerate,
          },
          afterList: this.getAndGenerate,
        },
        autocomplete_with_input: {
          tag: 'd-control-multiselect',
          props: {
            label: 'caption',
            taggable: true,
          },
          events: {
            open: this.getAndGenerate,
            'search-change': this.getAndGenerate,
            tag: this.addTag,
          },
          afterList: this.getAndGenerate,
        },
        input: {
          tag: 'd-control-input',
          events: {},
        },
      },
      currentRequest: '',
    }
  },
  watch: {
    // 'fields.city': {
    //   handler(nval) {
    //     if (nval) {
    //       this.city = nval
    //       this.form.city = nval
    //     }
    //   },
    //   deep: true,
    // },
    // initialCity: {
    //   handler(nval) {
    //     if (nval) {
    //       this.city = nval
    //       this.form.city = nval
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    fields: {
      async handler(nval) {
        if (nval.set) {
          await this.retrieveShipping()
          const v = this.variants.find(e => e.id === Number(nval.shipping_method_config.id))
          this.form.shipping_info = v
          this.form.shipping_info.fields.forEach(f => {
            const field = nval.shipping_info.find(e => e.field === f.id)
            f.props.value = field.value
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    thirdPartyCities() {
      if (this.config) {
        return this.config?.new_post_pickup?.fields[0]?.props.options
      }
      return []
    },
  },
  created() {
    if (this.getOnCreate) {
      this.getShippingVariants()
    }
  },
  mounted() {
  },
  methods: {
    getInitialCity() {
      const city = JSON.parse(window.current_city)
      if (city) {
        if (this.currentRequest) this.currentRequest.cancel()
        const cancelController = new AbortController();
        const base = receiveResource.config('signal', cancelController.signal)
        const executer = createResource(CITIES_URL, base)
        this.$nextTick(async () => {
          this.currentRequest = cancellablePromiseProxy(
            new Promise((resolve, reject) => {
              executer.execute({
                search: city.id,
              })
                .then(resolve, reject);
            }),
            { cancelController }
          ).then(({
            data: {
              items,
            },
          }) => {
            this.isLoading = false
            const [item] = items
            this.city = item
            this.form.city = item
          })
        })
      }
    },
    // getCityLabel,
    skip() {
      this.$emit('skip')
    },
    async getCities(event, service, key, push, visible) {
      // this.city_config.params = {
      //   country_available__iso_code: this.country || getCookie(COUNTRY_CODE_COOKIE_NAME)
      // }
      getPaginatedProps(CITIES_URL, event, this.city_config, visible)
    },
    getCityLabel({ props: { title_ru: titleRu, title_uk: titleUk, area, region } }) {
      const lang = 'ru' === window.language
      const title = lang ? titleRu : titleUk
      let areaTitle
      if (area) {
        areaTitle = lang ? area.props.title_ru : area.props.title_uk
      }
      let regionTitle = ''
      if (region) {
        regionTitle = lang ? area.props.title_ru : area.props.title_uk
      }
      const res = [title, areaTitle, regionTitle].filter(el => el)
      return res.join(' - ')
    },
    changeChild(change, value, form, ref, selected, parentChange, parentValue) {
      if (selected) return
      this.$refs[ref][0].click()
      change(value)
      parentChange(parentValue)
      this.$emit('update', form)
    },
    changeParent(change, value, form, ref, selected) {
      if (selected) return
      this.$refs[ref][0].click()
      change(value)
      this.$emit('update', form)
    },
    addTag(event, field) {
      field.props.value = event
    },
    cityChange() {
      const pr = arg => new Promise((resolve, reject) => {
        resolve(arg)
        reject(new Error('error'))
      }).then(() => {
        this.city = arg
        this.form.city = arg
        this.$emit('city:change', arg)
      })
      this.$modal.show(
        () => import('@app/UiElements/Header/CityChange'),
        {
          info: {
            simpleSet: true,
            promise: pr,
          },
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
    eventGenerator(events, ...args) {
      return Object.entries(events).reduce((acc, e) => {
        const [key, val] = e
        acc[key] = $event => val($event, ...args)
        return acc
      }, {})
    },
    expandDependencies(f, p) {
      return p.dependencies.reduce((acc, obj) => {
        const path = obj.lookup_value_path.split('.')
        if (!this.form[obj.source]) return acc
        acc[obj.lookup] = pathOr('', path, this.form[obj.source])
        return acc
      }, {})
    },
    expandParams(f, p) {
      const dependencies = this.expandDependencies(f, p) || {}
      const refs = p.meta.reduce((acc, obj) => {
        const path = obj.name.split('.')
        acc[obj.key] = pathOr('', path, this[obj.from_field])
        return acc
      }, {})
      return {
        ...dependencies, ...refs,
      }
    },
    async getAndGenerate(event, field, parent, visible) {
      if (false === visible) return
      this.isLoading = true

      if (this.currentRequest) this.currentRequest.cancel()
      const cancelController = new AbortController();
      const base = receiveResource.config('signal', cancelController.signal)
      const executer = createResource(field.props.url, base)

      const params = this.expandParams(field, parent) || {}
      if (null !== event) field.props.search = event
      let offset = (field.props.meta.offset +
        field.props.meta.limit) || 0

      if (!visible) offset = FIRST_PAGE_LIMIT

      const limit = 100

      // nextTick - for get last value of field.props.search
      this.$nextTick(async () => {
        this.currentRequest = cancellablePromiseProxy(
          new Promise((resolve, reject) => {
            executer.execute({
              ...params, search: field.props.search, offset, limit,
            })
              .then(resolve, reject);
          }),
          { cancelController }
        ).then(({
          data: {
            items,
            pagination,
          },
        }) => {
          this.isLoading = false
          if (visible) {
            field.props.options.push(...items)
          } else {
            field.props.options = items
          }
          field.props.meta = pagination
        })
      })
    },
    internalCities() {
      if (this.config && this.config.pickup) {
        return this.config.pickup.fields[0].props.options
      }
      return []
    },
    async retrieveShipping() {
      const { data: { items } } = (await getSellerShippingServices.execute({ id: this.fields.shop }))
      this.list = items.reduce((acc, obj) => {
        const variant = obj.props.configs.map(el => ({ ...el, ...{ meta: obj.props.metadata, icon: obj.props.icon } }))
        acc.push({ ...obj, props: { ...obj.props, configs: variant } })
        return acc
      }, []).filter(el => el.props.configs.length)
      this.variants = items.reduce((acc, obj) => {
        const variant = obj.props.configs.map(el => ({ ...el, ...{ meta: obj.props.metadata, icon: obj.props.icon } }))
        acc.push(...variant)
        return acc
      }, [])
    },
    async getShippingVariants() {
      await this.retrieveShipping()
      // eslint-disable-next-line prefer-destructuring
      this.form.shipping_info = this.variants[0]
      // eslint-disable-next-line prefer-destructuring
      this.form.shipping_service = this.list[0]
      this.$nextTick(() => {
        this.$emit('update', this.form)
      })
    },
    check() {
      this.$emit('update', this.form)
    },
    getCustomLabel(obj, path) {
      if (!path.props.value_path) return path.props.label

      const l = JSON.parse(path.props.value_path).filter(o => pathOr(false, o.split('.'), obj)).map(o => pathOr(null, o.split('.'), obj))

      return l.join(', ') || obj
    },
  },
}
